<template>
  <div>
    <Header></Header>

    <div class="py-md-32 position-relative" style="padding-top:0!important;background-color:#f5f9fc;">
      <section class="page-section" id="about">
        <div class="container">

          <div class="text-center">
            <h2 class="section-heading">PGS-hub</h2>
            <h3 class="section-subheading text-muted mt-3">
              Welcome to PGS-hub
            </h3>
            <h3 class="section-subheading text-muted">
              Cutting-edge platform dedicated to polygenic score (PGS) analysis.
            </h3>
          </div>

          <ul class="timeline">

            <!-- 1 -->
            <li>
              <div class="timeline-image">
                <img class="img-fluid" :src="baseUrl + 'img/about/1.png'" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4 class="subheading">About PGS-hub Platform</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Welcome to PGS-hub. Our platform features eight single-ancestry PGS
                    algorithms and two multi-ancestry algorithms, providing comprehensive
                    tools for genetic risk assessment.
                  </p>
                </div>
              </div>
            </li>

            <!-- 2 -->
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="img-fluid" :src="baseUrl + 'img/about/2.png'" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4 class="subheading">Polygenic Score (PGS)</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    Polygenic Score estimates genetic predisposition by aggregating
                    multiple SNP effects derived from GWAS. It supports personalized
                    medicine and population-level risk stratification.
                  </p>
                </div>
              </div>
            </li>

            <!-- 3 -->
            <li>
              <div class="timeline-image">
                <img class="img-fluid" :src="baseUrl + 'img/about/3.png'" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4 class="subheading">How to Calculate PGS</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    PGS is computed as the weighted sum of SNP genotypes using effect
                    sizes derived from GWAS. The formula aggregates βi × Gi across all loci.
                  </p>
                </div>
              </div>
            </li>

            <!-- 4 -->
            <li class="timeline-inverted">
              <div class="timeline-image">
                <img class="img-fluid" :src="baseUrl + 'img/about/4.png'" alt="">
              </div>
              <div class="timeline-panel">
                <div class="timeline-heading">
                  <h4 class="subheading">Computational Challenges Solved</h4>
                </div>
                <div class="timeline-body">
                  <p class="text-muted">
                    PGS-hub enables users to run advanced methods such as LDpred2 and
                    PRS-CS efficiently, generating SNP weight files for downstream PLINK
                    scoring with minimal operational complexity.
                  </p>
                </div>
              </div>
            </li>

          </ul>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "@/components/commons/HeaderItem.vue"

export default {
  name: "HistoryTimeline",
  components: { Header },

  computed: {
    baseUrl() {
      // dev 下通常是 "/"
      // production 下是 "/pgs-hub/"
      return process.env.BASE_URL
    }
  }
}
</script>

<style scoped>
.page-section {
          padding: 120px 0;
}

.timeline {
  margin-top: 2rem;
  position: relative;
  padding: 0;
  list-style: none;
}

.timeline:before {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 40px;
          width: 2px;
          margin-left: -1.5px;
          content: "";
          background-color: #e9ecef;
}

.timeline>li {
          position: relative;
          min-height: 50px;
          margin-bottom: 50px;
}

.timeline>li:after,
.timeline>li:before {
          display: table;
          content: " ";
}

.timeline>li:after {
          clear: both;
}

.timeline>li .timeline-panel {
          position: relative;
          float: right;
          width: 100%;
          padding: 0 20px 0 100px;
          text-align: left;
}

.timeline>li .timeline-panel:before {
          right: auto;
          left: -15px;
          border-right-width: 15px;
          border-left-width: 0;
}

.timeline>li .timeline-panel:after {
          right: auto;
          left: -14px;
          border-right-width: 14px;
          border-left-width: 0;
}

.timeline>li .timeline-image {
          position: absolute;
          z-index: 100;
          left: 0;
          width: 80px;
          height: 80px;
          margin-left: 0;
          text-align: center;
          color: white;
          /* border: 1px solid #e9ecef; */
          /* border-radius: 100%; */
          /* background-color: #ffc800; */
}

.timeline>li .timeline-image h4,
.timeline>li .timeline-image .h4 {
          font-size: 10px;
          line-height: 14px;
          margin-top: 12px;
}

.timeline>li.timeline-inverted>.timeline-panel {
          float: right;
          padding: 0 20px 0 100px;
          text-align: left;
}

.timeline>li.timeline-inverted>.timeline-panel:before {
          right: auto;
          left: -15px;
          border-right-width: 15px;
          border-left-width: 0;
}

.timeline>li.timeline-inverted>.timeline-panel:after {
          right: auto;
          left: -14px;
          border-right-width: 14px;
          border-left-width: 0;
}

.timeline>li:last-child {
          margin-bottom: 0;
}

.timeline .timeline-heading h4,
.timeline .timeline-heading .h4 {
          margin-top: 0;
          color: inherit;
}

.timeline .timeline-heading h4.subheading,
.timeline .timeline-heading .subheading.h4 {
          text-transform: none;
}

.timeline .timeline-body>ul,
.timeline .timeline-body>p {
          margin-bottom: 0;
}

@media (min-width: 768px) {
          .timeline:before {
                    left: 50%;
          }

          .timeline>li {
                    min-height: 100px;
                    margin-bottom: 100px;
          }

          .timeline>li .timeline-panel {
                    float: left;
                    width: 41%;
                    padding: 0 20px 20px 30px;
                    text-align: right;
          }

          .timeline>li .timeline-image {
                    left: 50%;
                    width: 100px;
                    height: 100px;
                    margin-left: -50px;
          }

          .timeline>li .timeline-image h4,
          .timeline>li .timeline-image .h4 {
                    font-size: 13px;
                    line-height: 18px;
                    margin-top: 16px;
          }

          .timeline>li.timeline-inverted>.timeline-panel {
                    float: right;
                    padding: 0 30px 20px 20px;
                    text-align: left;
          }
}

@media (min-width: 1650px) {
          .timeline>li {
                    min-height: 150px;
          }

          .timeline>li .timeline-panel {
                    padding: 0 20px 20px;
          }

          .timeline>li .timeline-image {
                    width: 150px;
                    height: 150px;
                    margin-left: -75px;
          }

          .timeline>li .timeline-image h4,
          .timeline>li .timeline-image .h4 {
                    font-size: 18px;
                    line-height: 26px;
                    margin-top: 30px;
          }

          .timeline>li.timeline-inverted>.timeline-panel {
                    padding: 0 20px 20px;
          }
}

@media (min-width: 1200px) {
          .timeline>li {
                    min-height: 170px;
          }

          .timeline>li .timeline-panel {
                    padding: 0 20px 20px 100px;
          }

          .timeline>li .timeline-image {
                    width: 170px;
                    height: 170px;
                    margin-left: -85px;
          }

          .timeline>li .timeline-image h4,
          .timeline>li .timeline-image .h4 {
                    margin-top: 40px;
          }

          .timeline>li.timeline-inverted>.timeline-panel {
                    padding: 0 100px 20px 20px;
          }
}

.text-uppercase {
  text-transform: uppercase !important;
}

.timeline-body p {
  text-align: justify; /* 两端对齐 */
  margin-top: 1em;
}
</style>